<template>
  <thead class="show-for-large">
    <tr>
      <slot></slot>
    </tr>
  </thead>
</template>
<script setup></script>
